import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { InlineText2 } from '@cian/ui-kit/typography';

import * as styles from './styles.css';

interface ITabProps {
  id: string;
  label: string;
  isActive?: boolean | null;
  onClick(id: string): void;
}

export const Tab: React.FC<ITabProps> = ({ id, isActive, onClick, label }) => {
  return (
    <button data-testid="tab" {...mergeStyles(styles['tab'], isActive && styles['active'])} onClick={() => onClick(id)}>
      <InlineText2 whiteSpace="nowrap" userSelect="none">
        {label}
      </InlineText2>
    </button>
  );
};

Tab.displayName = 'Tab';
